<template>
  <div>
    <div v-show="!isExpanded" class="ai-customer-entry">
      <!-- 免费领资料 -->
      <div class="nav_item" @click="openGiftModal">
        <div class="nav_icon_gift">
          <img src="@/assets/free_gift.svg" alt="免费领资料" />
        </div>
        <div class="nav_text">免费领资料</div>
      </div>

       <!-- 电话咨询 -->
      <div class="nav_item nav_item_phone">
        <div class="phone-bubble">19103442742</div>
        <div class="nav_icon">
          <div class="nav_icon_phone"></div>
        </div>
        <div class="nav_text">电话咨询</div>
      </div>

      <!-- 人工客服 -->
      <div class="nav_item nav_item_customer">
        <div class="customer_bubble">
          <img src="@/assets/teacherWX.png" alt="客服微信" />
          <div class="bubble_tip">扫码添加客服微信</div>
        </div>
        <div class="nav_icon">
          <div class="nav_icon_customer"></div>
        </div>
        <div class="nav_text">人工客服</div>
      </div>

      <!-- AI助手 -->
      <div class="nav_item nav_item_AI" @click="handleExpand">
          <Transition name="bubble-fade">
          <div v-if="showBubble" class="guide-bubble" @click.stop="handleBubbleClick">
            <span class="bubble-text">有问题？点我咨询~</span>
            <button class="bubble-close" @click.stop="closeBubble">×</button>
            <div class="bubble-arrow"></div>
          </div>
        </Transition>
        <div class="nav_icon_AI">
          <img src="https://yx-education.oss-cn-zhangjiakou.aliyuncs.com/yixiaoying-smile.png" alt="AI客服" />
        </div>
        <div class="nav_text">AI助手</div>
      </div>

      <!-- 引导气泡 -->
      <!-- <Transition name="bubble-fade">
        <div v-if="showBubble" class="guide-bubble" @click.stop="handleBubbleClick">
          <span class="bubble-text">有问题？点我咨询~</span>
          <button class="bubble-close" @click.stop="closeBubble">×</button>
          <div class="bubble-arrow"></div>
        </div>
      </Transition>
      <div class="ai-icon">
        <img src="https://yx-education.oss-cn-zhangjiakou.aliyuncs.com/yixiaoying-smile.png" alt="AI客服" />
      </div> -->
    </div>

    <client-only>
      <Teleport to="body">
        <Transition name="chat-bubble">
          <div
            v-show="isExpanded || iframeLoaded"
            :class="{ 'is-hidden': !isExpanded }"
            class="ai-chat-window"
            :style="windowStyle"
            @mousedown="startDrag"
          >
            <div 
              ref="dragHandleRef"
              class="ai-chat-header"
              :class="{ 'is-dragging': isDragging }"
            >
              <div class="header-left">
                
                <div class="header-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12c0 1.54.36 2.98.97 4.29L1 23l6.71-1.97C9.02 21.64 10.46 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.4 0-2.74-.35-3.92-.98l-.28-.15-2.91.86.86-2.91-.15-.28C5.35 15.74 5 14.4 5 13c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7z"/>
                    <circle cx="9" cy="12" r="1.5"/>
                    <circle cx="15" cy="12" r="1.5"/>
                    <path d="M12 16c1.66 0 3-1.34 3-3h-6c0 1.66 1.34 3 3 3z"/>
                  </svg>
                </div>
                <span class="header-title">易小鹦 智能客服</span>
              </div>
              <div class="header-actions">
                <button class="action-btn minimize-btn" @click.stop="handleMinimize" title="最小化">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 13H5v-2h14v2z"/>
                  </svg>
                </button>
                <button class="action-btn close-btn" @click.stop="handleClose" title="关闭">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                  </svg>
                </button>
              </div>
            </div>

            <div class="ai-chat-body">
              <!-- iframe 始终渲染，确保 load 事件能触发 -->
              <iframe
                v-if="iframeLoaded"
                ref="iframeRef"
                src="https://chat.tdxl-edu.cn/174590921694224/apps/177028123067857/"
                class="ai-iframe"
                frameborder="0"
                allow="microphone"
                @load="handleIframeLoad"
                @error="handleIframeError"
              />
              <!-- 加载中状态（覆盖层） -->
              <div v-if="isLoading" class="loading-container">
                <div class="loading-spinner"></div>
                <span class="loading-text">正在连接智能客服...</span>
              </div>
              <!-- 错误状态（覆盖层） -->
              <div v-if="loadError" class="error-container">
                <div class="error-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                  </svg>
                </div>
                <span class="error-text">{{ errorMessage }}</span>
                <button class="retry-btn" @click="handleRetry">重新连接</button>
              </div>
              
              <!-- 右下角调整大小手柄 -->
              <div
                class="resize-handle"
                @mousedown.stop="startResize"
                title="调整大小"
              >
              <svg t="1773306261755" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12287" id="mx_n_1773306261755" width="32" height="32">
              <path d="M859.136 164.864c-10.24-10.24-26.112-10.24-36.352 0L164.864 822.784c-10.24 10.24-10.24 26.112 0 36.352 5.12 5.12 11.776 7.68 17.92 7.68s13.312-2.56 17.92-7.68L859.136 201.216c9.728-9.728 9.728-26.112 0-36.352zM822.784 411.136l-411.648 411.648c-10.24 10.24-10.24 26.112 0 36.352 5.12 5.12 11.776 7.68 17.92 7.68s13.312-2.56 17.92-7.68l411.648-411.648c10.24-10.24 10.24-26.112 0-36.352-9.728-10.24-26.112-10.24-35.84 0zM822.784 656.896l-165.888 165.888c-10.24 10.24-10.24 26.112 0 36.352 5.12 5.12 11.776 7.68 17.92 7.68s13.312-2.56 17.92-7.68l165.888-165.888c10.24-10.24 10.24-26.112 0-36.352-9.728-10.24-26.112-10.24-35.84 0z" p-id="12288" fill="#1296db">
              </path>
              </svg>
              </div>
            </div>
          </div>
        </Transition>
      </Teleport>
    </client-only>

    <!-- 免费领资料弹窗 -->
    <client-only>
      <Teleport to="body">
        <Transition name="gift-fade">
          <div v-if="showGiftModal" class="gift_modal_mask" @click.self="closeGiftModal">
            <div class="gift_modal_content">
              <img class="gift_modal_bg" src="@/assets/addwx_bg.png" alt="添加助教老师" />
              <img class="gift_qr_code" src="@/assets/teacherWX.png" alt="助教微信二维码" />
            </div>
          </div>
        </Transition>
      </Teleport>
    </client-only>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick } from "vue";
import { useDraggable } from "@vueuse/core";

const WINDOW_MIN_WIDTH = 300;
const WINDOW_MIN_HEIGHT = 400;
const DEFAULT_WIDTH = 350;
const DEFAULT_HEIGHT = 650;
const MARGIN = 20;

const isExpanded = ref(false);
const iframeLoaded = ref(false);
const dragHandleRef = ref(null);
const iframeRef = ref(null);
const showBubble = ref(false);
const isLoading = ref(false);
const loadError = ref(false);
const errorMessage = ref('加载超时，请重试');
const isMobile = ref(false);
const isReduce = ref(false);

const windowX = ref(0);
const windowY = ref(0);
const windowWidth = ref(DEFAULT_WIDTH);
const windowHeight = ref(DEFAULT_HEIGHT);

// 气泡定时器
let bubbleTimer = null;
let autoHideTimer = null;
// 加载超时定时器
let loadTimeout = null;

// 关闭气泡
const closeBubble = () => {
  showBubble.value = false;
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.setItem("ai-bubble-closed", "true");
  }
  clearTimeout(autoHideTimer);
};

// 点击气泡打开客服窗口
const handleBubbleClick = () => {
  handleExpand();
};

const initPosition = () => {
  if (typeof window !== "undefined") {
    windowX.value = window.innerWidth - DEFAULT_WIDTH - MARGIN;
    windowY.value = window.innerHeight - DEFAULT_HEIGHT - MARGIN;
  }
};

const { isDragging } = useDraggable(dragHandleRef, {
  initialValue: { x: windowX.value, y: windowY.value },
  onMove: (position) => {
    const maxX = window.innerWidth - windowWidth.value;
    const maxY = window.innerHeight - windowHeight.value;
    windowX.value = Math.max(0, Math.min(position.x, maxX));
    windowY.value = Math.max(0, Math.min(position.y, maxY));
  },
});

const windowStyle = computed(() => {
  if (isMobile.value) {
    return {
      left: 0,
      top: 0,
      width: '100vw',
      height: '100vh',
    };
  }
  return {
    left: windowX.value + "px",
    top: windowY.value + "px",
    width: windowWidth.value + "px",
    height: windowHeight.value + "px",
  };
});

const handleExpand = () => {
  // 关闭气泡
  showBubble.value = false;
  console.log('handleExpand 加载...',isReduce.value);
  if(isReduce.value){
    isExpanded.value = true;
    console.log('[AI客服] 已加载...');
    return;
  }
  clearTimeout(autoHideTimer);
  
  initPosition();
  isExpanded.value = true;
  isLoading.value = true;
  loadError.value = false;
  errorMessage.value = '加载超时，请重试';
  
  nextTick(() => {
    iframeLoaded.value = true;
    // 30秒超时检测（跨域 iframe 加载可能较慢）
    loadTimeout = setTimeout(() => {
      if (isLoading.value) {
        errorMessage.value = '加载超时，请重试';
        loadError.value = true;
        isLoading.value = false;
      }
    }, 30000);
  });
};

// iframe 加载完成
const handleIframeLoad = () => {
  console.log('[AI客服] iframe load 事件触发');
  clearTimeout(loadTimeout);
  isLoading.value = false;
  loadError.value = false;
};

// iframe 加载错误
const handleIframeError = (e) => {
  console.log('[AI客服] iframe error 事件触发', e);
  clearTimeout(loadTimeout);
  errorMessage.value = '连接失败，请检查网络';
  loadError.value = true;
  isLoading.value = false;
};

// 重试加载
const handleRetry = () => {
  loadError.value = false;
  isLoading.value = true;
  errorMessage.value = '加载超时，请重试';
  iframeLoaded.value = false;
  nextTick(() => {
    iframeLoaded.value = true;
    // 重新设置超时检测
    loadTimeout = setTimeout(() => {
      if (isLoading.value) {
        errorMessage.value = '加载超时，请重试';
        loadError.value = true;
        isLoading.value = false;
      }
    }, 30000);
  });
};

const handleMinimize = () => {
  isExpanded.value = false;
  isReduce.value = true;
};

const handleClose = () => {
  isExpanded.value = false;
  isReduce.value = true;
  // iframeLoaded.value = false;
  // isReduce.value = false;
};

const handleResize = () => {
  // 检测是否为移动端
  isMobile.value = window.innerWidth < 768;
  
  if (isExpanded.value && !isMobile.value) {
    const maxX = window.innerWidth - windowWidth.value;
    const maxY = window.innerHeight - windowHeight.value;
    windowX.value = Math.max(0, Math.min(windowX.value, maxX));
    windowY.value = Math.max(0, Math.min(windowY.value, maxY));
  }
};

// 键盘快捷键处理
const handleKeydown = (e) => {
  if (e.key === 'Escape' && isExpanded.value) {
    handleMinimize();
  }
};

onMounted(() => {
  // 初始化移动端检测
  isMobile.value = window.innerWidth < 768;
  initPosition();
  window.addEventListener("resize", handleResize);
  document.addEventListener("keydown", handleKeydown);
  
  // 检查会话中是否已关闭气泡
  if (typeof sessionStorage !== "undefined" && sessionStorage.getItem("ai-bubble-closed") !== "true") {
    // 2秒后显示气泡
    bubbleTimer = setTimeout(() => {
      showBubble.value = true;
      // 5秒后自动隐藏
      autoHideTimer = setTimeout(() => {
        showBubble.value = false;
      }, 5000);
    }, 2000);
  }

  // 异步预加载 AI 助手：等主内容空闲后再创建 iframe
  const preloadAi = () => {
    iframeLoaded.value = true;
    isReduce.value = true; // 标记已预加载，点击入口时直接弹出
  };

  if (typeof requestIdleCallback !== "undefined") {
    requestIdleCallback(preloadAi);
  } else {
    setTimeout(preloadAi, 3000); // 兼容低版本浏览器
  }
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  document.removeEventListener("keydown", handleKeydown);
  clearTimeout(bubbleTimer);
  clearTimeout(autoHideTimer);
  clearTimeout(loadTimeout);
});


// 调整大小相关状态
const isResizing = ref(false);
const resizeStartX = ref(0);
const resizeStartY = ref(0);
const resizeStartWidth = ref(0);
const resizeStartHeight = ref(0);

// --- 调整大小逻辑 ---
const startResize = (e) => {
  isResizing.value = true;
  resizeStartX.value = e.clientX;
  resizeStartY.value = e.clientY;
  resizeStartWidth.value = windowWidth.value;
  resizeStartHeight.value = windowHeight.value;

  document.addEventListener('mousemove', onResize);
  document.addEventListener('mouseup', stopResize);
};

const onResize = (e) => {
  if (!isResizing.value) return;

  const deltaX = e.clientX - resizeStartX.value;
  const deltaY = e.clientY - resizeStartY.value;

  // 从右下角调整大小
  let newWidth = resizeStartWidth.value + deltaX;
  let newHeight = resizeStartHeight.value + deltaY;

  // 限制最小尺寸
  const minWidth = WINDOW_MIN_WIDTH;
  const minHeight = WINDOW_MIN_HEIGHT;
  if (newWidth < minWidth) newWidth = minWidth;
  if (newHeight < minHeight) newHeight = minHeight;

  // 限制最大尺寸，不超过浏览器窗口大小
  const maxWidth = window.innerWidth - windowX.value;
  const maxHeight = window.innerHeight - windowY.value;
  if (newWidth > maxWidth) newWidth = maxWidth;
  if (newHeight > maxHeight) newHeight = maxHeight;

  windowWidth.value = newWidth;
  windowHeight.value = newHeight;
};

const stopResize = () => {
  isResizing.value = false;
  document.removeEventListener('mousemove', onResize);
  document.removeEventListener('mouseup', stopResize);
};

// 免费领资料
const showGiftModal = ref(false);
const openGiftModal = () => {
  showGiftModal.value = true;
};
const closeGiftModal = () => {
  showGiftModal.value = false;
};

</script>

<style lang="scss" scoped>
.ai-customer-entry {
  position: fixed;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #DFF0C2;
  border-radius: 12px 0 0 12px;
  box-shadow: 0 6px 24px 4px rgba(0, 0, 0, 0.1);
  overflow: visible;
  cursor: default;

  .nav_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    padding: 8px 0 10px 0;
    margin: 0 6px;
    cursor: pointer;
    color: #76809C;
    font-size: 11px;
    text-decoration: none;
    border-bottom: 1px solid #d8d8d8;
    overflow: visible;

    &:first-child {
      position: relative;
      z-index: 1;
      padding-top: 20px;
      .nav_icon_gift {
        width: 46px;
        height: 46px;
        margin-top: -24px;
        margin-bottom: 4px;
        overflow: visible;
        img {
          transform: scale(1.3);
          transform-origin: center bottom;
        }
      }
    }

    &:last-child {
      position: relative;
      border-bottom: none;
      padding: 0 0 4px 0;
      .nav_icon_AI {
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    &:hover {
      color: #1758D6;
    }

    .nav_icon {
      width: 22px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 4px 0;
      .nav_icon_phone {
        width: 100%;
        height: 100%;
        background: url('@/assets/icon_phone.svg') no-repeat center / contain;
      }
      .nav_icon_customer {
        width: 100%;
        height: 100%;
        background: url('@/assets/icon_customer.svg') no-repeat center / contain;
      }
    }

    .nav_text {
      line-height: 1.2;
      text-align: center;
      white-space: nowrap;
    }

  }

  .nav_item_phone {
    position: relative;

    .phone-bubble {
      position: absolute;
      right: calc(100% + 10px);
      top: 50%;
      transform: translateY(-50%);
      background: #fff;
      color: #333;
      padding: 7px 14px;
      border-radius: 6px;
      font-size: 14px;
      white-space: nowrap;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease 0.5s, visibility 0.2s ease 0.5s;
      z-index: 10;
      cursor: text;
      user-select: text;

      &::after {
        content: '';
        position: absolute;
        right: -6px;
        top: 50%;
        transform: translateY(-50%);
        border-width: 6px;
        border-style: solid;
        border-color: transparent transparent transparent #fff;
      }
    }

    &:hover .phone-bubble {
      opacity: 1;
      visibility: visible;
      transition-delay: 0s;
    }
  }

  .nav_item:hover .nav_icon_phone {
    background: url('@/assets/icon_phone_hover.svg') no-repeat center / contain;
  }
  .nav_item:hover .nav_icon_customer {
    background: url('@/assets/icon_customer_hover.svg') no-repeat center / contain;
  }

  .nav_item_customer {
    position: relative;
    
    .customer_bubble {
      position: absolute;
      right: calc(100% + 20px);
      top: 50%;
      transform: translateY(-50%);
      width: 140px;
      background: #fff;
      padding: 12px;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease 0.5s, visibility 0.2s ease 0.5s;
      z-index: 10;
      text-align: center;

      img {
        width: 100%;
        height: auto;
        display: block;
        border-radius: 4px;
      }

      .bubble_tip {
        font-size: 12px;
        color: #666;
        margin-top: 8px;
        white-space: nowrap;
        line-height: 1.4;
      }

      &::after {
        content: '';
        position: absolute;
        right: -6px;
        top: 50%;
        transform: translateY(-50%);
        border-width: 6px;
        border-style: solid;
        border-color: transparent transparent transparent #fff;
      }
    }

    &:hover .customer_bubble {
      opacity: 1;
      visibility: visible;
      transition-delay: 0s;
    }
  }
  
  .nav_item_AI {
    position: relative;
  // 引导气泡样式
  .guide-bubble {
    position: absolute;
    left: -180px;
    top: 50%;
    transform: translateY(-50%);
    background: linear-gradient(135deg, #409eff 0%, #2563eb 100%);
    color: #fff;
    padding: 10px 32px 10px 14px;
    border-radius: 20px;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
    cursor: default;

    .bubble-text {
      font-size: 14px;
      font-weight: 500;
    }

    .bubble-close {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      color: rgba(255, 255, 255, 0.8);
      cursor: pointer;
      font-size: 18px;
      line-height: 1;
      padding: 0;
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s ease;

      &:hover {
        color: #fff;
      }
    }

    .bubble-arrow {
      position: absolute;
      right: -8px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-left-color: #2563eb;
      border-right: none;
    }
  }
  }
}

// 气泡动画
.bubble-fade-enter-active {
  animation: bubble-in 0.4s ease-out;
}

.bubble-fade-leave-active {
  animation: bubble-out 0.3s ease-in;
}

@keyframes bubble-in {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes bubble-out {
  0% {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-50%) translateX(10px);
  }
}
</style>

<style lang="scss">
.ai-chat-window {
  position: fixed;
  width: 350px;
  height: 650px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  // 预加载时隐藏：DOM 保留，但不可见、不可交互、不占位
  &.is-hidden {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transform: translateX(100vw) translateY(100vh);
  }
}

.ai-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(135deg, #409eff 0%, #2563eb 100%);
  cursor: move;
  user-select: none;
  flex-shrink: 0;

  &.is-dragging {
    cursor: grabbing;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .header-icon {
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 18px;
      height: 18px;
      color: #fff;
    }
  }

  .header-title {
    font-size: 15px;
    font-weight: 500;
    color: #fff;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .action-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;

    svg {
      width: 16px;
      height: 16px;
      color: #fff;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    &.close-btn:hover {
      background: rgba(255, 82, 82, 0.8);
    }
  }
}

.ai-chat-body {
  flex: 1;
  overflow: hidden;
  background: #f5f5f5;
  position: relative;
}

// 加载状态
.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  gap: 16px;

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #e5e7eb;
    border-top-color: #409eff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-text {
    color: #666;
    font-size: 14px;
  }
}

// 错误状态
.error-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  gap: 12px;

  .error-icon {
    width: 48px;
    height: 48px;
    color: #f56c6c;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .error-text {
    color: #666;
    font-size: 14px;
  }

  .retry-btn {
    margin-top: 8px;
    padding: 8px 24px;
    background: linear-gradient(135deg, #409eff 0%, #2563eb 100%);
    color: #fff;
    border: none;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
    }
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.ai-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.chat-bubble-enter-active {
  animation: ai-bubble-in 0.3s ease-out;
}

.chat-bubble-leave-active {
  animation: ai-bubble-out 0.2s ease-in;
}

@keyframes ai-bubble-in {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes ai-bubble-out {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
}

// 移动端适配
@media (max-width: 767px) {
  .ai-chat-window {
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0;
    
    .ai-chat-header {
      cursor: default;
      padding: 14px 16px;
      
      // 移动端隐藏最小化按钮
      .minimize-btn {
        display: none;
      }
    }
  }
}

/* 调整大小的手柄样式 */
.resize-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: se-resize;
  background: linear-gradient(135deg, transparent 50%, #2563eb 50%);
  z-index: 10;
  opacity: 0.7;
}


// 免费领资料
.gift_modal_mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.gift_modal_content {
  position: relative;
  width: 320px;
}

.gift_modal_bg {
  display: block;
  width: 100%;
  height: auto;
}

.gift_qr_code {
  position: absolute;
  top: 330px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 180px;
  height: auto;
  border-radius: 8px;
}

.gift-fade-enter-active,
.gift-fade-leave-active {
  transition: opacity 0.3s ease;
}

.gift-fade-enter-from,
.gift-fade-leave-to {
  opacity: 0;
}
</style>
